import { FC } from 'react';
import { useIntl } from 'react-intl';

interface PickingProgressBarProps {
  current: number;
  total: number;
}

const PickingProgressBar: FC<PickingProgressBarProps> = ({
  current,
  total,
}) => {
  const intl = useIntl();
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="w-100 mb-4">
      <div className="d-flex justify-content-between mb-1">
        <span className="fw-bold" style={{ fontSize: 18 }}>
          {intl.formatMessage(
            { id: 'picking.progressLabel' },
            { current, total }
          )}
        </span>
        <span className="text-muted">{percentage}%</span>
      </div>
      <div className="progress" style={{ height: 8 }}>
        <div
          className="progress-bar bg-primary"
          role="progressbar"
          style={{ width: `${percentage}%` }}
          aria-valuenow={current}
          aria-valuemin={0}
          aria-valuemax={total}
          aria-label={intl.formatMessage(
            { id: 'picking.progressLabel' },
            { current, total }
          )}
        />
      </div>
    </div>
  );
};

export { PickingProgressBar };
